import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_LIST } from '@core/services/web-api/api-list';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, map, mergeMap, take } from 'rxjs/operators';
import { NgIf } from '@angular/common';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';

const CONTENTS$ = new BehaviorSubject<{ [key: string]: DynamicContent }>({});

export class DynamicContent {
  header: string;
  body: string;
}

@Component({
  selector: 'app-static-content',
  templateUrl: './static-content.component.html',
  styleUrls: ['./static-content.component.scss'],
  standalone: true,
  imports: [NgIf, SvgIconComponent]
})
export class StaticContentComponent implements OnInit {
  @Input() contentId: string;
  @Input() showHeader = true;
  @Input() size = 0;

  isLoading = true;
  content: DynamicContent;
  body: SafeHtml;

  constructor(private httpClient: HttpClient, private domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    CONTENTS$
      .pipe(
        take(1),
        mergeMap(
          (contents => contents[this.contentId] ?
            of(contents) :
            this.httpClient.get<{ name: string; title: string; text: string }>(API_LIST.getStaticContent(this.contentId)).pipe(map((content) => ({
              ...contents,
              [content.name]: {
                header: content.title,
                body: content.text
              }
            })),
              catchError(() => of(contents)))
          )
        )
      )
      .subscribe(contents => {
        this.content = contents[this.contentId] || null;
        this.body = this.content?.body ? this.domSanitizer.bypassSecurityTrustHtml(this.content?.body) : null;
        this.isLoading = false;
        CONTENTS$.next(contents);
      });
  }
}
